import { Grid } from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ExperienceCard from './ExperienceCard';
import * as S from './styles';

const PAGE_SIZE = 6;

const ExperienceList = ({ filters, searchState, experiences, buscaAtual }) => {
  const history = useHistory();
  const [page, setPage] = useState(1);

  const selected = filters?.filters || {};

  // US-21: aplica os filtros da sidebar (localizacao, subcategorias, preco) client-side
  const filtered = useMemo(() => {
    const list = Array.isArray(experiences) ? experiences : [];
    const locs = selected.localizations || [];
    const subs = selected.subcategories || [];
    const range = selected.priceRange || null;
    return list.filter((exp) => {
      if (locs.length) {
        const loc = exp.localization || exp.city?.cityName || null;
        if (!locs.includes(loc)) return false;
      }
      if (subs.length) {
        const expSubs = (exp.subcategories || []).map((s) => s.name);
        if (!expSubs.some((name) => subs.includes(name))) return false;
      }
      if (range) {
        const price = Number(exp.price) || 0;
        if (price < range[0] || price > range[1]) return false;
      }
      return true;
    });
  }, [experiences, selected]);

  // volta para a primeira pagina sempre que o filtro/resultado muda
  useEffect(() => {
    setPage(1);
  }, [filtered.length]);

  const pageCount = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const pageItems = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  // US-24: cabecalho com criterios da busca + botao Editar
  const categoryLabel = searchState?.categoria?.name || 'Todas as categorias';
  const locationLabel = searchState?.cidade?.cityName
    ? searchState.cidade.cityName
    : 'Em todas as localizações';
  const dateLabel = searchState?.datas?.abreviada || null;

  return (
    <div>
      <S.ResultHeader>
        <div className="criteria">
          <span className="category">Categoria: {categoryLabel}</span>
          <span className="location">{locationLabel}</span>
          {dateLabel && <span className="dates">{dateLabel}</span>}
        </div>
        <button type="button" className="edit" onClick={() => history.goBack()}>
          Editar
        </button>
      </S.ResultHeader>

      <S.Wrapper>
        <Grid container>
          <Grid item xs={12}>
            <Grid container>
              {pageItems.map((exp, index) => (
                <Grid item xs={12} key={exp.id || index}>
                  <ExperienceCard
                    experience={exp}
                    title={exp.name}
                    description={exp.description}
                    valueDiscounted={exp.originalPrice}
                    value={exp.price}
                    id={exp.id}
                    buscaAtual={buscaAtual}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>

        {pageCount > 1 && (
          <S.PaginationWrapper>
            <Pagination
              count={pageCount}
              page={page}
              onChange={(event, value) => setPage(value)}
              color="primary"
              shape="rounded"
            />
          </S.PaginationWrapper>
        )}
      </S.Wrapper>
    </div>
  );
};

export default ExperienceList;
